import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { UserType } from '@/entities/user'
import { PaginationSearchParams } from '@/shared/api'

import { getFAQs, type TFAQSearchParams } from './get-faqs'
import { getNotices } from './get-notices'

export const supportQueries = {
  all: () => ['support'],
  notices: (userType: UserType, searchParams: PaginationSearchParams) =>
    queryOptions({
      queryKey: [...supportQueries.all(), 'notices', userType, searchParams],
      queryFn: () => getNotices({ userType, searchParams }),
    }),
  noticesInfinite: (userType: UserType) =>
    infiniteQueryOptions({
      queryKey: [...supportQueries.all(), 'notices', 'infinite', userType],
      queryFn: ({ pageParam }) =>
        getNotices({ userType, searchParams: { page: pageParam } }),
      initialPageParam: 1,
      getNextPageParam: lastPage => {
        const { currentPage, lastPage: last } = lastPage

        return currentPage < last ? currentPage + 1 : undefined
      },
    }),
  faqsInfinite: (
    userType: UserType,
    searchParams: Pick<TFAQSearchParams, 'category' | 'keyword'>,
  ) =>
    infiniteQueryOptions({
      queryKey: [
        ...supportQueries.all(),
        'faqs',
        'infinite',
        userType,
        searchParams,
      ],
      queryFn: ({ pageParam }) =>
        getFAQs({
          userType,
          searchParams: {
            ...searchParams,
            page: pageParam,
            size: 10,
          },
        }),
      initialPageParam: 1,
      getNextPageParam: lastPage => {
        const { currentPage, lastPage: last } = lastPage

        return currentPage < last ? currentPage + 1 : undefined
      },
    }),
}
